import { User } from '@/api/ms-authentication/services/interfaces';
import userHasPermittedRoles from '@/utils/userHasPermittedRoles';
import { BusinessAccountStore } from '@/store';

export default (user: User) => {
  return (userHasPermittedRoles(user) && BusinessAccountStore.allDomains.length > 0);
}
